import React from 'react';
import config from 'config';

import { Typography, Button, Card } from '../../../alf-design';

const WithoutClaims = ({ error }) => {
  return (
    <Card>
      <div>
        <Typography type="h2" component="h2" className="mb-[24px]">
          Report a Loss
        </Typography>
        {error?.entity === 'claims' && error?.err?.status === 500 ? (
          <Typography type="caption1">
            Claim information is not currently available. Please try again
            later.
          </Typography>
        ) : (
          <Typography type="caption1">
            {`To file a claim, click the button below or call Claims Services at `}
            <a
              href={`tel:866-230-3758`}
              className="text-legacy-primary underline"
              tabIndex="0"
            >
              (866) 230-3758.
            </a>
            <br />
            Please have your policy number ready for identification.
          </Typography>
        )}
        <Button
          id="Report-Loss-button"
          type="primary"
          onClick={() => window.open(config.fnol)}
          className="mt-[16px]"
        >
          File a Claim
        </Button>
      </div>
    </Card>
  );
};

export default WithoutClaims;
